import React from 'react';

import { Box } from '@amzn/awsui-components-react-v3';

import clsx from 'clsx';
import { isEmpty } from 'lodash';

import { MPN_AUTO_SUGGEST_MESSAGES } from './constants';

interface MPNOptionsProps {
  suggestions: any;
  activeIndex: number;
  mpnInput: string;
  hideSuggest: boolean;
  onClick: (val: string) => void;
}

export const MPNOptions = ({ mpnInput, suggestions, activeIndex, onClick, hideSuggest }: MPNOptionsProps) => {
  if (mpnInput?.length < 3 && !suggestions?.loading && suggestions?.values?.length <= 0 && !hideSuggest) {
    return (
      <Box>
        <ul>
          {mpnInput?.length > 0 && mpnInput?.length < 4 && (
            <li>
              <i>{MPN_AUTO_SUGGEST_MESSAGES.MPN_MINIMUM_CHARACTERS}</i>
            </li>
          )}
        </ul>
      </Box>
    );
  }
  return (
    <>
      {!suggestions?.loading && suggestions?.values?.length > 0 && (
        <Box>
          <ul>
            {mpnInput?.length > 1 && mpnInput?.length < 3 && (
              <li>
                <i>{MPN_AUTO_SUGGEST_MESSAGES.MPN_MINIMUM_CHARACTERS}</i>
              </li>
            )}
            {suggestions?.values?.map((mpn: any, i: number) => {
              return (
                <li
                  key={mpn?.validMPN}
                  className={clsx({ active: activeIndex === i && !isEmpty(mpn?.validMPN) })}
                  aria-label={activeIndex === i ? `selected-mpn-option-${mpn?.validMPN}` : ''}
                >
                  <Box>
                    {isEmpty(mpn?.validMPN) ? (
                      <i>{MPN_AUTO_SUGGEST_MESSAGES[mpn?.message]}</i>
                    ) : (
                      <div
                        aria-label={`mpn-option-${mpn?.validMPN}`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onClick(mpn?.validMPN);
                        }}
                      >
                        {mpn?.validMPN}
                      </div>
                    )}
                  </Box>
                </li>
              );
            })}
          </ul>
        </Box>
      )}
    </>
  );
};
